{
  "EMOJI": {
    "PLACEHOLDER": "Αναζήτηση emojis",
    "NOT_FOUND": "Κανένα emoji δεν ταιριάζει με την αναζήτησή σας",
    "REMOVE": "Διαγραφή"
  },
  "EMOJI_ICON_PICKER": {
    "TABS": {
      "ICONS": "Icons",
      "EMOJIS": "Emojis"
    },
    "SEARCH_EMOJI": "Search emoji…",
    "SEARCH_ICON": "Search icons…",
    "FREQUENTLY_USED": "Frequently used",
    "NO_EMOJI": "Κανένα emoji δεν ταιριάζει με την αναζήτησή σας",
    "NO_ICON": "No icons match your search",
    "REMOVE": "Διαγραφή",
    "STYLE": {
      "OUTLINE": "Outline icons",
      "FILLED": "Filled icons"
    },
    "COLORS": {
      "SLATE": "Slate",
      "RED": "Red",
      "ORANGE": "Orange",
      "AMBER": "Amber",
      "GREEN": "Green",
      "TEAL": "Teal",
      "BLUE": "Blue",
      "INDIGO": "Indigo",
      "VIOLET": "Violet",
      "PINK": "Pink"
    }
  }
}
